import Vue from "vue";
import VueFire from "vuefire";
import App from "./App.vue";
import router from "./router";
import bus from "./bus";
import "./registerServiceWorker";

Vue.config.productionTip = false;

Vue.use(VueFire);

window.initMap = function() {
  bus.$emit("googleMapsLoaded");
};

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js